import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { LitPage } from '../lit-page';

/**
 * luna-skeleton — shared loading-placeholder block (BR-70 skeleton pattern).
 *
 * Geometry (width/height/radius) is set by the consuming page on the element
 * itself via its own scoped CSS, e.g.
 *   luna-skeleton.app-picker__skeleton-row { height: 84px; }
 * This component owns the surface fill + shimmer sweep (a highlight gradient
 * tinted with the active theme's --mbw-topbar-solid via color-mix, moving
 * left→right, reduced-motion aware). Pages must not override
 * `background` (shorthand would erase the shine layer); use `background-color`
 * longhand only if a different fill is ever needed. Animation is declared via
 * longhands so pages may add staggered `animation-delay` (e.g. nth-child)
 * without fighting the shorthand.
 */
@customElement('luna-skeleton')
export class LunaSkeleton extends LitPage {
  content() {
    return html``;
  }

  styles() {
    return css`
      luna-skeleton {
        display: block;
        border-radius: var(--luna-radius-card);
        background-color: var(--luna-surface-field);
        background-image: linear-gradient(
          105deg,
          color-mix(in srgb, var(--mbw-topbar-solid) 0%, transparent) 35%,
          color-mix(in srgb, var(--mbw-topbar-solid) 18%, transparent) 50%,
          color-mix(in srgb, var(--mbw-topbar-solid) 0%, transparent) 65%
        );
        background-repeat: no-repeat;
        background-size: 250% 100%;
        background-position-x: 150%;
        animation-name: luna-skeleton-shimmer;
        animation-duration: 1.4s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
      }

      @keyframes luna-skeleton-shimmer {
        from {
          background-position-x: 150%;
        }
        to {
          background-position-x: -50%;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        luna-skeleton {
          animation-name: none;
          background-image: none;
        }
      }
    `;
  }
}
